import { useState, useEffect } from 'react';
import { auth } from '../lib/supabase';

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const { data: { subscription } } = auth.onAuthStateChange((_event, session) => {
      const sessionUser = session?.user;
      setUser(sessionUser);
      setLoading(false);
      if (session?.error) {
        console.error('Auth state change error:', session.error);
        setError(session.error);
      }
    });

    return () => {
      if (subscription) subscription.unsubscribe();
    };
  }, []);

  const signIn = async (email, password) => {
    try {
      setLoading(true);
      setError(null);
      const result = await auth.signInWithPassword({ email: email, password: password });
      return result.user;
    } catch (err) {
      console.error('Sign in error:', 'Authentication error');
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const signUp = async (email, password) => {
    try {
      setLoading(true);
      setError(null);
      const result = await auth.signUp({ email: email, password: password });
      return result.user;
    } catch (err) {
      console.error('Sign up error:', 'Authentication error');
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const signOut = async () => {
    try {
      setLoading(true);
      setError(null);
      await auth.signOut();
    } catch (err) {
      console.error('Sign out error:', err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    user,
    loading,
    error,
    signIn,
    signUp,
    signOut,
    isAuthenticated: !!user
  };
};
